export class MessageRoomPartialID {

    constructor(public readonly projectID: string,
                public readonly opponentID: string,){
    }
}




// WEBPACK FOOTER //
// ./src/domain/model/entity.ts